import {connect, Dispatch} from 'react-redux';
import CommentMarkers from './CommentMarkers';
import ReduxState from '../../types/ReduxState';
import {RouteComponentProps, withRouter} from 'react-router';
import Actions from '../../redux/Actions';

const mapStateToProps = (state: ReduxState, ownProps: RouteComponentProps) => {
   return {
      ...ownProps,
      markers: state.markers,
      playDuration: state.playDuration || 0,
      selectedCommentTime: state.selectedComment ? state.selectedComment.time : -1,
      player: state.player,
      reviewId: state.reviewId,
      reviewVersion: state.currentReviewVersion
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>) => {
   return {
      setSelectedComment: (id: string) => {
         dispatch(Actions.setSelectedComment(id));
      }
   };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CommentMarkers));
